import { render } from "./ChatMessageInput.vue?vue&type=template&id=0bc7b316&scoped=true"
import script from "./ChatMessageInput.vue?vue&type=script&lang=js"
export * from "./ChatMessageInput.vue?vue&type=script&lang=js"

import "./ChatMessageInput.vue?vue&type=style&index=0&id=0bc7b316&scoped=true&lang=css"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc7b316"]])

export default __exports__